import { render, staticRenderFns } from "./BaseMarkdown.vue?vue&type=template&id=4e0a2bfe&"
import script from "./BaseMarkdown.vue?vue&type=script&lang=ts&"
export * from "./BaseMarkdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports